// src/Components/About/AboutAssociation.jsx
import React from "react";
import { motion } from "framer-motion";
import "./AboutAssociation.css"; 
import GroupPhoto from "../../Assets/images/about-image.jpg"; 

const AboutAssociation = () => {
  return (
    <section className="about-association">
      {/* Group Image with Heading Overlay */}
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="group-image-container"
      >
        <img
          src={GroupPhoto}
          alt="University of Ghana Alumni Association in Liberia"
          className="group-image"
        />
        <div className="overlay">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="about-heading"
          >
            About the Association
          </motion.h1>
        </div>
      </motion.div>

      {/* About Sections */}
      <div className="about-sections">
        {/* Brief History */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="about-section"
        >
          <h2>Brief History</h2>
          <p>
                    The roots of the UGAA Liberia can be traced back to 2007 when a group of ten to fifteen like-minded individuals, who had primarily attended the University of Ghana, Legon, came together with a noble objective. They sought to provide social solidarity for their fellow alumni who had, to some extent, felt alienated from mainstream Liberian society due to the extended time they had spent outside the country. This group became a rallying point for many individuals, providing support and companionship. Members who were financially able generously extended their assistance to those in need.
Meetings were held in members' homes on a rotational basis, where ideas were shared, and the collective strength of this remarkable group was nurtured. Financial contributions were made to address the organizational developmental needs, ensuring the growth and sustainability of the association. Today, we honor and remember the pioneers who paved the way for the UGAA Liberia. I would like to mention some of their names, including Atty. Thomas S.W. Neufville, Atty. Victoria W. Duncan, Hon. T. Wilson Gaye, Prof. Dr. Samuel N. Duo, Rev. Nathaniel Sikeley, Mr. Foley D.K. Freeman, Mr. Laveto Akoi-Forkpa, Cllr. Ambrose Darius Nmah, Alpha Andrew, Vani Karmo, Mr. James Thompson, John J. Morris, and many others whose efforts have brought us to this auspicious moment.
In 2013, the group elected its first set of officers, with Atty. Thomas S.W. Neufville serving as the President. This marked a significant milestone as the UGAA Liberia held an elaborate launch ceremony at the SKD Gymnasium in Paynesville City. We were honored to have Professor O. Johnson from the University of Ghana's Political Department as our keynote speaker. However, as time went by, the group experienced a decline in momentum due to the departure of key members for further studies abroad and the unfortunate passing of some of our cherished colleagues.
Fast forward to 2020, new officers were elected. And I Mr. Daniel Blamoh Nah assumed the helm of affair as President. Our primary objective was to revive the association and establish the necessary structures for its continued growth. In that the same year, the UGAA Liberia finalized its Articles of Incorporation, registered with the Liberia Business Registry, and became a legal entity under the laws of the Republic of Liberia. We proudly announce that the active membership of the UGAA Liberia Chapter has exceeded 70 members, with more individuals expressing their desire to join as they learn about the association's positive impact.

          </p>
        </motion.div>

        {/* Formation */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="about-section"
        >
          <h2>Official Recognition</h2>
          <p>
              Though our journey began in <strong>2007</strong>, the University of Ghana Alumni Association Liberia (UGAAL) was officially recognized in <strong>2023</strong>. Since then, we have grown into a vibrant community that unites graduates, fosters mentorship, drives impactful projects, and proudly gives back to our communities and institutions.
          </p>
        </motion.div>

        {/* Who Qualifies */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="about-section"
        >
          <h2>Who Qualifies as an Alumnus</h2>
          <p>
            Membership is open to all graduates and former students of the University of Ghana and its affiliate institutions, including GIMPA, UPSA, Wisconsin, and others, residing in Liberia or abroad. This includes individuals who have successfully completed undergraduate, graduate, or professional programs, irrespective of nationality, united by a shared commitment to lifelong learning, networking, and community impact.
          </p>
        </motion.div>

        {/* Relationship with University */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="about-section"
        >
          <h2>Relationship with the University</h2>
          <p>
            The Alumni Association maintains a collaborative relationship with the
            University of Ghana to promote its mission, support student
            initiatives, and strengthen alumni engagement in academic and
            professional spheres.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutAssociation;
